export interface IStep {
  step: number;
  text: string;
  showPartnerText: boolean;
  showStepper: boolean;
  next?: Pages;
  prev?: Pages;
  secondTitle?: string;
  hideExitApplication?: boolean;
}

export enum Pages {
  EnterPhoneNumber = 'EnterPhoneNumber',
  CustomerDetails = 'CustomerDetails',
  EmailVerification = 'EmailVerification',
  ChooseYourPlan = 'ChooseYourPlan',
  PaymentDetails = 'PaymentDetails',
  Thanks = 'Thanks',
  LandingPage = 'LandingPage',
}

const pageSteps: { [key in keyof typeof Pages]: IStep } = {
  EnterPhoneNumber: {
    step: 0,
    text: 'Flexible Monthly Payments',
    showStepper: true,
    showPartnerText: true,
    next: Pages.CustomerDetails,
    secondTitle: 'Get Pre-Qualified in Seconds!',
  },
  CustomerDetails: {
    step: 1,
    text: 'Checking Your Options',
    showStepper: true,
    showPartnerText: true,
    next: Pages.EmailVerification,
    prev: Pages.EnterPhoneNumber,
  },
  EmailVerification: {
    step: 1,
    text: 'Email Verification Required',
    showStepper: true,
    showPartnerText: true,
    next: Pages.ChooseYourPlan,
    prev: Pages.CustomerDetails,
  },
  ChooseYourPlan: { step: 2, text: 'Choose Payment Plan', showStepper: true, showPartnerText: true, next: Pages.PaymentDetails, prev: Pages.EmailVerification },
  PaymentDetails: { step: 3, text: 'Enter Payment Details', showStepper: true, showPartnerText: true, next: Pages.Thanks, prev: Pages.PaymentDetails },
  Thanks: { step: 4, text: 'See You Soon!', showStepper: false, showPartnerText: true, hideExitApplication: true },
  LandingPage: { step: -1, text: '', showStepper: true, showPartnerText: true, hideExitApplication: true },
};

export default pageSteps;
